import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-canceled',
  templateUrl: './payment-canceled.component.html',
  styleUrls: ['./payment-canceled.component.scss']
})
export class PaymentCanceledComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
